// import React, { useState, useEffect, useRef } from 'react';
// import {
//   DashboardOutlined, ProjectOutlined, CodeOutlined,
//   HistoryOutlined, UserOutlined, SafetyCertificateOutlined,
//   MailOutlined, MenuOutlined, CloseOutlined, LogoutOutlined,
// } from '@ant-design/icons';

// const NAV_ITEMS = [
//   { key: 'overview',     label: 'Overview',     icon: <DashboardOutlined /> },
//   { key: 'about',        label: 'About',        icon: <UserOutlined /> },
//   { key: 'projects',     label: 'Projects',     icon: <ProjectOutlined /> },
//   { key: 'skills',       label: 'Skills',       icon: <CodeOutlined /> },
//   { key: 'experience',   label: 'Experience',   icon: <HistoryOutlined /> },
//   { key: 'certificates', label: 'Certificates', icon: <SafetyCertificateOutlined /> },
//   { key: 'admin',        label: 'Admin Panel',  icon: <MailOutlined /> },
// // Navbar.jsx — rename key 'imageuploader' → 'image'
// { key: 'image', label: 'Image Uploader', icon: <MailOutlined /> },
// { key: 'philosophy', label: 'philosophy', icon: <MailOutlined /> },
// { key: 'HeroControlPage', label: 'HeroControlPage', icon: <MailOutlined /> },
// { key: 'ThemePage', label: 'ThemePage', icon: <MailOutlined /> },
// { key: 'BlogPage', label: 'BlogPage', icon: <MailOutlined /> },
// { key: 'AuthorsList', label: 'AuthorsList', icon: <MailOutlined /> },




// ];

// export default function Navbar({ current, onNavigate, onLogout, username }) {
//   const [drawerOpen,    setDrawerOpen]    = useState(false);
//   const [avatarMenuOpen, setAvatarMenuOpen] = useState(false);
//   const drawerRef  = useRef(null);
//   const avatarRef  = useRef(null);

//   /* Close on outside click */
//   useEffect(() => {
//     function handleClick(e) {
//       if (drawerOpen    && drawerRef.current  && !drawerRef.current.contains(e.target))  setDrawerOpen(false);
//       if (avatarMenuOpen && avatarRef.current && !avatarRef.current.contains(e.target)) setAvatarMenuOpen(false);
//     }
//     document.addEventListener('mousedown', handleClick);
//     return () => document.removeEventListener('mousedown', handleClick);
//   }, [drawerOpen, avatarMenuOpen]);

//   /* Lock body scroll when drawer open */
//   useEffect(() => {
//     document.body.style.overflow = drawerOpen ? 'hidden' : '';
//     return () => { document.body.style.overflow = ''; };
//   }, [drawerOpen]);

//   const handleNav = (key) => { onNavigate(key); setDrawerOpen(false); };
//   const initials  = username ? username.slice(0, 2).toUpperCase() : 'AD';

//   return (
//     <>
//       {/* ════════════════════════════════ NAVBAR ═══════════════════════════════ */}
//       <nav style={S.navbar}>

//         {/* Left: hamburger + brand */}
//         <div style={S.navLeft}>
//           <button
//             style={S.hamburger}
//             onClick={() => setDrawerOpen(true)}
//             aria-label="Open menu"
//             onMouseEnter={e => e.currentTarget.style.background = 'rgba(200,240,74,0.1)'}
//             onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
//           >
//             <MenuOutlined style={{ fontSize: 18, color: '#c8f04a' }} />
//           </button>

//           <div style={S.brand}>
//             <span style={S.brandStar}>✦</span>
//             <span style={S.brandWord}>PORTFOLIO</span>
//           </div>
//         </div>

//         {/* Center: desktop-only links (hidden via CSS on mobile) */}

//         {/* Right: avatar */}
//         <div style={{ position: 'relative' }} ref={avatarRef}>
//           <button
//             style={S.avatarBtn}
//             onClick={() => setAvatarMenuOpen(v => !v)}
//             aria-label="User menu"
//           >
//             <span style={S.avatarCircle}>{initials}</span>
//           </button>

//           {avatarMenuOpen && (
//             <div style={S.avatarMenu}>
//               <div style={S.avatarMenuHeader}>
//                 <span style={S.avatarCircleSm}>{initials}</span>
//                 <div>
//                   <div style={{ color: '#f0f0f0', fontSize: 13, fontWeight: 600 }}>{username || 'Admin'}</div>
//                   <div style={{ color: '#6b7280', fontSize: 11 }}>Administrator</div>
//                 </div>
//               </div>
//               <div style={S.divider} />
//               <button
//                 style={S.avatarMenuItem}
//                 onClick={() => { setAvatarMenuOpen(false); onLogout(); }}
//                 onMouseEnter={e => e.currentTarget.style.background = '#1f1f1f'}
//                 onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
//               >
//                 <LogoutOutlined style={{ marginRight: 8, color: '#ef4444' }} />
//                 <span style={{ color: '#ef4444' }}>Sign out</span>
//               </button>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* ════════════════════════════════ OVERLAY ══════════════════════════════ */}
//       {drawerOpen && (
//         <div style={S.overlay} onClick={() => setDrawerOpen(false)} />
//       )}

//       {/* ════════════════════════════════ DRAWER ═══════════════════════════════ */}
//       <div
//         ref={drawerRef}
//         style={{
//           ...S.drawer,
//           transform: drawerOpen ? 'translateX(0)' : 'translateX(-100%)',
//         }}
//       >
//         {/* Drawer header */}
//         <div style={S.drawerHeader}>
//           <div style={S.brand}>
//             <span style={S.brandStar}>✦</span>
//             <span style={S.brandWord}>PORTFOLIO</span>
//           </div>
//           <button
//             style={S.closeBtn}
//             onClick={() => setDrawerOpen(false)}
//             aria-label="Close menu"
//             onMouseEnter={e => e.currentTarget.style.background = '#2d2d2d'}
//             onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
//           >
//             <CloseOutlined style={{ fontSize: 14, color: '#9ca3af' }} />
//           </button>
//         </div>

//         {/* Drawer nav items */}
//         <nav style={S.drawerNav}>
//           {NAV_ITEMS.map(({ key, label, icon }) => {
//             const isActive = current === key;
//             return (
//               <button
//                 key={key}
//                 onClick={() => handleNav(key)}
//                 style={{ ...S.drawerItem, ...(isActive ? S.drawerItemActive : {}) }}
//                 onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
//                 onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
//               >
//                 <span style={{ fontSize: 15, display: 'flex', alignItems: 'center', width: 20 }}>{icon}</span>
//                 <span style={{ flex: 1 }}>{label}</span>
//                 {isActive && <span style={S.activeDot} />}
//               </button>
//             );
//           })}
//         </nav>

//         {/* Drawer footer */}
//         <div style={S.drawerFooter}>
//           <div style={S.drawerUserRow}>
//             <span style={S.avatarCircleSm}>{initials}</span>
//             <div style={{ flex: 1 }}>
//               <div style={{ color: '#f0f0f0', fontSize: 13, fontWeight: 600 }}>{username || 'Admin'}</div>
//               <div style={{ color: '#6b7280', fontSize: 11 }}>Administrator</div>
//             </div>
//             <button
//               style={S.logoutBtn}
//               onClick={() => { setDrawerOpen(false); onLogout(); }}
//               title="Sign out"
//               onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.2)'}
//               onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.08)'}
//             >
//               <LogoutOutlined style={{ fontSize: 14, color: '#ef4444' }} />
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// /* ─── Styles ──────────────────────────────────────────────────── */
// const S = {
//   navbar: {
//     position: 'sticky',
//     top: 0,
//     zIndex: 100,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     gap: '12px',
//     background: '#0f0f0f',
//     borderBottom: '1px solid #1f1f1f',
//     padding: '0 16px',
//     height: '56px',
//     boxShadow: '0 2px 16px rgba(0,0,0,0.5)',
//     fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
//   },
//   navLeft: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     flexShrink: 0,
//   },
//   hamburger: {
//     background: 'transparent',
//     border: '1px solid #2d2d2d',
//     borderRadius: '7px',
//     cursor: 'pointer',
//     padding: '7px 9px',
//     display: 'flex',
//     alignItems: 'center',
//     transition: 'background 0.15s',
//   },
//   brand: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '7px',
//   },
//   brandStar: {
//     color: '#c8f04a',
//     fontSize: '18px',
//     lineHeight: 1,
//   },
//   brandWord: {
//     color: '#c8f04a',
//     fontWeight: 700,
//     fontSize: '12px',
//     letterSpacing: '3px',
//     fontFamily: 'monospace',
//   },
//   desktopLinks: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '2px',
//     flex: 1,
//     justifyContent: 'center',
//     flexWrap: 'nowrap',
//     overflow: 'hidden',
//   },
//   desktopLink: {
//     background: 'transparent',
//     border: 'none',
//     color: '#9ca3af',
//     cursor: 'pointer',
//     padding: '6px 10px',
//     borderRadius: '6px',
//     fontSize: '13px',
//     fontWeight: 500,
//     display: 'flex',
//     alignItems: 'center',
//     transition: 'color 0.15s, background 0.15s',
//     whiteSpace: 'nowrap',
//   },
//   desktopLinkActive: {
//     color: '#c8f04a',
//     background: 'rgba(200,240,74,0.08)',
//   },
//   avatarBtn: {
//     background: 'none',
//     border: 'none',
//     cursor: 'pointer',
//     padding: 0,
//     display: 'flex',
//     alignItems: 'center',
//   },
//   avatarCircle: {
//     width: '34px',
//     height: '34px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg,#c8f04a,#86ef4d)',
//     color: '#0a0a0a',
//     fontWeight: 800,
//     fontSize: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     letterSpacing: '0.5px',
//     border: '2px solid rgba(200,240,74,0.35)',
//     flexShrink: 0,
//   },
//   avatarCircleSm: {
//     width: '30px',
//     height: '30px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg,#c8f04a,#86ef4d)',
//     color: '#0a0a0a',
//     fontWeight: 800,
//     fontSize: '11px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     flexShrink: 0,
//     letterSpacing: '0.5px',
//   },
//   avatarMenu: {
//     position: 'absolute',
//     top: 'calc(100% + 10px)',
//     right: 0,
//     background: '#1a1a1a',
//     border: '1px solid #2d2d2d',
//     borderRadius: '10px',
//     minWidth: '196px',
//     boxShadow: '0 16px 40px rgba(0,0,0,0.55)',
//     overflow: 'hidden',
//     zIndex: 200,
//   },
//   avatarMenuHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//     padding: '14px 14px',
//     background: '#161616',
//   },
//   divider: {
//     height: '1px',
//     background: '#2a2a2a',
//   },
//   avatarMenuItem: {
//     width: '100%',
//     background: 'transparent',
//     border: 'none',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     padding: '12px 14px',
//     fontSize: '13px',
//     transition: 'background 0.15s',
//   },
//   /* Overlay */
//   overlay: {
//     position: 'fixed',
//     inset: 0,
//     background: 'rgba(0,0,0,0.65)',
//     backdropFilter: 'blur(2px)',
//     zIndex: 150,
//   },
//   /* Drawer */
//   drawer: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     height: '100vh',
//     width: '260px',
//     background: '#0f0f0f',
//     borderRight: '1px solid #1f1f1f',
//     display: 'flex',
//     flexDirection: 'column',
//     zIndex: 160,
//     transition: 'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
//     boxShadow: '6px 0 40px rgba(0,0,0,0.6)',
//     fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
//   },
//   drawerHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     padding: '0 14px',
//     height: '56px',
//     borderBottom: '1px solid #1f1f1f',
//     flexShrink: 0,
//   },
//   closeBtn: {
//     background: 'transparent',
//     border: '1px solid #2d2d2d',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     padding: '6px 8px',
//     display: 'flex',
//     alignItems: 'center',
//     transition: 'background 0.15s',
//   },
//   drawerNav: {
//     flex: 1,
//     overflowY: 'auto',
//     padding: '10px 8px',
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '2px',
//   },
//   drawerItem: {
//     width: '100%',
//     background: 'transparent',
//     border: 'none',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '11px',
//     padding: '11px 14px',
//     borderRadius: '8px',
//     color: '#9ca3af',
//     fontSize: '14px',
//     fontWeight: 500,
//     textAlign: 'left',
//     transition: 'background 0.15s, color 0.15s',
//     position: 'relative',
//   },
//   drawerItemActive: {
//     background: 'rgba(200,240,74,0.1)',
//     color: '#c8f04a',
//   },
//   activeDot: {
//     width: '6px',
//     height: '6px',
//     borderRadius: '50%',
//     background: '#c8f04a',
//     flexShrink: 0,
//   },
//   drawerFooter: {
//     borderTop: '1px solid #1f1f1f',
//     padding: '14px',
//     flexShrink: 0,
//   },
//   drawerUserRow: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//   },
//   logoutBtn: {
//     background: 'rgba(239,68,68,0.08)',
//     border: '1px solid rgba(239,68,68,0.2)',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     padding: '7px 9px',
//     display: 'flex',
//     alignItems: 'center',
//     transition: 'background 0.15s',
//   },
// };

// /* ── Responsive: hide desktop links on mobile ─────────────────── */
// if (typeof document !== 'undefined') {
//   const id = 'pf-navbar-mq';
//   if (!document.getElementById(id)) {
//     const s = document.createElement('style');
//     s.id = id;
//     s.textContent = `
//       @media (max-width: 860px) { .pf-desktop-links { display: none !important; } }
//       @media (min-width: 861px) { .pf-desktop-links { display: flex !important; } }
//     `;
//     document.head.appendChild(s);
//   }
// }
import React, { useState, useEffect, useRef } from 'react';
import {
  DashboardOutlined, ProjectOutlined, CodeOutlined,
  HistoryOutlined, UserOutlined, SafetyCertificateOutlined,
  MailOutlined, MenuOutlined, CloseOutlined, LogoutOutlined,
  FileTextOutlined, TeamOutlined, DownOutlined,
} from '@ant-design/icons';

const NAV_ITEMS = [
  { key: 'overview',     label: 'Overview',     icon: <DashboardOutlined /> },
  { key: 'about',        label: 'About',        icon: <UserOutlined /> },
  { key: 'projects',     label: 'Projects',     icon: <ProjectOutlined /> },
  { key: 'skills',       label: 'Skills',       icon: <CodeOutlined /> },
  { key: 'experience',   label: 'Experience',   icon: <HistoryOutlined /> },
  { key: 'certificates', label: 'Certificates', icon: <SafetyCertificateOutlined /> },
  { key: 'admin',        label: 'Admin Panel',  icon: <MailOutlined /> },
  { key: 'image',        label: 'Image Uploader', icon: <MailOutlined /> },
  { key: 'philosophy',   label: 'Philosophy',   icon: <MailOutlined /> },
  { key: 'HeroControlPage', label: 'Hero Control', icon: <MailOutlined /> },
  { key: 'ThemePage',    label: 'Theme',        icon: <MailOutlined /> },
  {
    key: 'blogs',
    label: 'Blogs',
    icon: <FileTextOutlined />,
    children: [
      { key: 'BlogPage',    label: 'Blog Posts', icon: <FileTextOutlined /> },
      { key: 'AuthorsList', label: 'Authors',    icon: <TeamOutlined /> },
            { key: 'Dashboard', label: 'Dashboard',    icon: <TeamOutlined /> },
      { key: 'PostsList', label: 'PostsList',    icon: <TeamOutlined /> },
      { key: 'SiteSettings', label: 'SiteSettings',    icon: <TeamOutlined /> },

    ],
  },
];

export default function Navbar({ current, onNavigate, onLogout, username }) {
  const [drawerOpen,    setDrawerOpen]    = useState(false);
  const [avatarMenuOpen, setAvatarMenuOpen] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState({});
  const drawerRef  = useRef(null);
  const avatarRef  = useRef(null);

  /* Close on outside click */
  useEffect(() => {
    function handleClick(e) {
      if (drawerOpen    && drawerRef.current  && !drawerRef.current.contains(e.target))  setDrawerOpen(false);
      if (avatarMenuOpen && avatarRef.current && !avatarRef.current.contains(e.target)) setAvatarMenuOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [drawerOpen, avatarMenuOpen]);

  /* Lock body scroll when drawer open */
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  /* Auto-expand a group if the active page lives inside it */
  useEffect(() => {
    NAV_ITEMS.forEach(item => {
      if (item.children && item.children.some(c => c.key === current)) {
        setExpandedGroups(prev => (prev[item.key] ? prev : { ...prev, [item.key]: true }));
      }
    });
  }, [current]);

  const handleNav = (key) => { onNavigate(key); setDrawerOpen(false); };
  const toggleGroup = (key) => setExpandedGroups(prev => ({ ...prev, [key]: !prev[key] }));
  const initials  = username ? username.slice(0, 2).toUpperCase() : 'AD';

  return (
    <>
      {/* ════════════════════════════════ NAVBAR ═══════════════════════════════ */}
      <nav style={S.navbar}>

        {/* Left: hamburger + brand */}
        <div style={S.navLeft}>
          <button
            style={S.hamburger}
            onClick={() => setDrawerOpen(true)}
            aria-label="Open menu"
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(200,240,74,0.1)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <MenuOutlined style={{ fontSize: 18, color: '#c8f04a' }} />
          </button>

          <div style={S.brand}>
            <span style={S.brandStar}>✦</span>
            <span style={S.brandWord}>PORTFOLIO</span>
          </div>
        </div>

        {/* Right: avatar */}
        <div style={{ position: 'relative' }} ref={avatarRef}>
          <button
            style={S.avatarBtn}
            onClick={() => setAvatarMenuOpen(v => !v)}
            aria-label="User menu"
          >
            <span style={S.avatarCircle}>{initials}</span>
          </button>

          {avatarMenuOpen && (
            <div style={S.avatarMenu}>
              <div style={S.avatarMenuHeader}>
                <span style={S.avatarCircleSm}>{initials}</span>
                <div>
                  <div style={{ color: '#f0f0f0', fontSize: 13, fontWeight: 600 }}>{username || 'Admin'}</div>
                  <div style={{ color: '#6b7280', fontSize: 11 }}>Administrator</div>
                </div>
              </div>
              <div style={S.divider} />
              <button
                style={S.avatarMenuItem}
                onClick={() => { setAvatarMenuOpen(false); onLogout(); }}
                onMouseEnter={e => e.currentTarget.style.background = '#1f1f1f'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <LogoutOutlined style={{ marginRight: 8, color: '#ef4444' }} />
                <span style={{ color: '#ef4444' }}>Sign out</span>
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* ════════════════════════════════ OVERLAY ══════════════════════════════ */}
      {drawerOpen && (
        <div style={S.overlay} onClick={() => setDrawerOpen(false)} />
      )}

      {/* ════════════════════════════════ DRAWER ═══════════════════════════════ */}
      <div
        ref={drawerRef}
        style={{
          ...S.drawer,
          transform: drawerOpen ? 'translateX(0)' : 'translateX(-100%)',
        }}
      >
        {/* Drawer header */}
        <div style={S.drawerHeader}>
          <div style={S.brand}>
            <span style={S.brandStar}>✦</span>
            <span style={S.brandWord}>PORTFOLIO</span>
          </div>
          <button
            style={S.closeBtn}
            onClick={() => setDrawerOpen(false)}
            aria-label="Close menu"
            onMouseEnter={e => e.currentTarget.style.background = '#2d2d2d'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <CloseOutlined style={{ fontSize: 14, color: '#9ca3af' }} />
          </button>
        </div>

        {/* Drawer nav items */}
        <nav style={S.drawerNav}>
          {NAV_ITEMS.map((item) => {
            const { key, label, icon, children } = item;

            /* ── Group item (e.g. Blogs) ───────────────────────── */
            if (children && children.length) {
              const isOpen = !!expandedGroups[key];
              const isChildActive = children.some(c => c.key === current);
              return (
                <div key={key}>
                  <button
                    onClick={() => toggleGroup(key)}
                    style={{ ...S.drawerItem, ...(isChildActive ? S.drawerItemActive : {}) }}
                    onMouseEnter={e => { if (!isChildActive) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
                    onMouseLeave={e => { if (!isChildActive) e.currentTarget.style.background = 'transparent'; }}
                  >
                    <span style={{ fontSize: 15, display: 'flex', alignItems: 'center', width: 20 }}>{icon}</span>
                    <span style={{ flex: 1 }}>{label}</span>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease',
                      }}
                    >
                      <DownOutlined style={{ fontSize: 10 }} />
                    </span>
                  </button>

                  <div
                    style={{
                      ...S.submenuWrap,
                      maxHeight: isOpen ? `${children.length * 44 + 8}px` : '0px',
                    }}
                  >
                    <div style={S.submenu}>
                      {children.map((child) => {
                        const isActive = current === child.key;
                        return (
                          <button
                            key={child.key}
                            onClick={() => handleNav(child.key)}
                            style={{ ...S.drawerSubItem, ...(isActive ? S.drawerItemActive : {}) }}
                            onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
                            onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
                          >
                            <span style={{ fontSize: 13, display: 'flex', alignItems: 'center', width: 18 }}>{child.icon}</span>
                            <span style={{ flex: 1 }}>{child.label}</span>
                            {isActive && <span style={S.activeDot} />}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            }

            /* ── Regular flat item ─────────────────────────────── */
            const isActive = current === key;
            return (
              <button
                key={key}
                onClick={() => handleNav(key)}
                style={{ ...S.drawerItem, ...(isActive ? S.drawerItemActive : {}) }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
              >
                <span style={{ fontSize: 15, display: 'flex', alignItems: 'center', width: 20 }}>{icon}</span>
                <span style={{ flex: 1 }}>{label}</span>
                {isActive && <span style={S.activeDot} />}
              </button>
            );
          })}
        </nav>

        {/* Drawer footer */}
        <div style={S.drawerFooter}>
          <div style={S.drawerUserRow}>
            <span style={S.avatarCircleSm}>{initials}</span>
            <div style={{ flex: 1 }}>
              <div style={{ color: '#f0f0f0', fontSize: 13, fontWeight: 600 }}>{username || 'Admin'}</div>
              <div style={{ color: '#6b7280', fontSize: 11 }}>Administrator</div>
            </div>
            <button
              style={S.logoutBtn}
              onClick={() => { setDrawerOpen(false); onLogout(); }}
              title="Sign out"
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.2)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.08)'}
            >
              <LogoutOutlined style={{ fontSize: 14, color: '#ef4444' }} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

/* ─── Styles ──────────────────────────────────────────────────── */
const S = {
  navbar: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    background: '#0f0f0f',
    borderBottom: '1px solid #1f1f1f',
    padding: '0 16px',
    height: '56px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.5)',
    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
  },
  navLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexShrink: 0,
  },
  hamburger: {
    background: 'transparent',
    border: '1px solid #2d2d2d',
    borderRadius: '7px',
    cursor: 'pointer',
    padding: '7px 9px',
    display: 'flex',
    alignItems: 'center',
    transition: 'background 0.15s',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
  },
  brandStar: {
    color: '#c8f04a',
    fontSize: '18px',
    lineHeight: 1,
  },
  brandWord: {
    color: '#c8f04a',
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '3px',
    fontFamily: 'monospace',
  },
  avatarBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
  },
  avatarCircle: {
    width: '34px',
    height: '34px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg,#c8f04a,#86ef4d)',
    color: '#0a0a0a',
    fontWeight: 800,
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    letterSpacing: '0.5px',
    border: '2px solid rgba(200,240,74,0.35)',
    flexShrink: 0,
  },
  avatarCircleSm: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg,#c8f04a,#86ef4d)',
    color: '#0a0a0a',
    fontWeight: 800,
    fontSize: '11px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    letterSpacing: '0.5px',
  },
  avatarMenu: {
    position: 'absolute',
    top: 'calc(100% + 10px)',
    right: 0,
    background: '#1a1a1a',
    border: '1px solid #2d2d2d',
    borderRadius: '10px',
    minWidth: '196px',
    boxShadow: '0 16px 40px rgba(0,0,0,0.55)',
    overflow: 'hidden',
    zIndex: 200,
  },
  avatarMenuHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '14px 14px',
    background: '#161616',
  },
  divider: {
    height: '1px',
    background: '#2a2a2a',
  },
  avatarMenuItem: {
    width: '100%',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '12px 14px',
    fontSize: '13px',
    transition: 'background 0.15s',
  },
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.65)',
    backdropFilter: 'blur(2px)',
    zIndex: 150,
  },
  drawer: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '260px',
    background: '#0f0f0f',
    borderRight: '1px solid #1f1f1f',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 160,
    transition: 'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
    boxShadow: '6px 0 40px rgba(0,0,0,0.6)',
    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 14px',
    height: '56px',
    borderBottom: '1px solid #1f1f1f',
    flexShrink: 0,
  },
  closeBtn: {
    background: 'transparent',
    border: '1px solid #2d2d2d',
    borderRadius: '6px',
    cursor: 'pointer',
    padding: '6px 8px',
    display: 'flex',
    alignItems: 'center',
    transition: 'background 0.15s',
  },
  drawerNav: {
    flex: 1,
    overflowY: 'auto',
    padding: '10px 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  drawerItem: {
    width: '100%',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '11px',
    padding: '11px 14px',
    borderRadius: '8px',
    color: '#9ca3af',
    fontSize: '14px',
    fontWeight: 500,
    textAlign: 'left',
    transition: 'background 0.15s, color 0.15s',
    position: 'relative',
  },
  drawerItemActive: {
    background: 'rgba(200,240,74,0.1)',
    color: '#c8f04a',
  },
  submenuWrap: {
    overflow: 'hidden',
    transition: 'max-height 0.25s ease',
  },
  submenu: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    marginLeft: '22px',
    paddingLeft: '12px',
    marginTop: '2px',
    marginBottom: '4px',
    borderLeft: '1px solid #2a2a2a',
  },
  drawerSubItem: {
    width: '100%',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    padding: '9px 12px',
    borderRadius: '7px',
    color: '#8a8f98',
    fontSize: '13px',
    fontWeight: 500,
    textAlign: 'left',
    transition: 'background 0.15s, color 0.15s',
    position: 'relative',
  },
  activeDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    background: '#c8f04a',
    flexShrink: 0,
  },
  drawerFooter: {
    borderTop: '1px solid #1f1f1f',
    padding: '14px',
    flexShrink: 0,
  },
  drawerUserRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  logoutBtn: {
    background: 'rgba(239,68,68,0.08)',
    border: '1px solid rgba(239,68,68,0.2)',
    borderRadius: '6px',
    cursor: 'pointer',
    padding: '7px 9px',
    display: 'flex',
    alignItems: 'center',
    transition: 'background 0.15s',
  },
};

/* ── Responsive: hide desktop links on mobile ─────────────────── */
if (typeof document !== 'undefined') {
  const id = 'pf-navbar-mq';
  if (!document.getElementById(id)) {
    const s = document.createElement('style');
    s.id = id;
    s.textContent = `
      @media (max-width: 860px) { .pf-desktop-links { display: none !important; } }
      @media (min-width: 861px) { .pf-desktop-links { display: flex !important; } }
    `;
    document.head.appendChild(s);
  }
}